module.exports = "/fonts/OpenSans-SemiBold.ttf";